module.exports = __webpack_public_path__ + "src/app/images/floor_switcher.svg";